export { default } from './HocFormContent';
